import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useMutation } from '@apollo/react-hooks';
import { EDIT_FLOATING_RATE } from '../../../graphql/rates/mutation';
import { FloatingRates } from '../../../graphql/rates/types/FloatingRates';
import { EditFloatingRateVariables } from '../../../graphql/rates/types/EditFloatingRate';
import ConfirmationButtons from '../../ConfirmationButtons/ConfirmationButtons';

interface EditTEGProps {
  year: number;
  excellentRate: number;
  teg: number;
  goodRate: number;
  handleClose: () => void;
}

const rateToPercent = (rate: number) => (rate * 100).toFixed(2);
const percentToRate = (percent: string) => (Number(percent) || 0) / 100;

const EditTEG = (props: EditTEGProps) => {
  const { year, excellentRate, teg, goodRate, handleClose } = props;

  const [newExellentRate, setNewExellentRate] = useState(
    rateToPercent(excellentRate),
  );
  const [newTeg, setNewTeg] = useState<string>(rateToPercent(teg));
  const [newGoodRate, setNewGoodRate] = useState(rateToPercent(goodRate));

  const [updateTEG] = useMutation<FloatingRates, EditFloatingRateVariables>(
    EDIT_FLOATING_RATE,
  );

  const handleEditTEG = () => {
    updateTEG({
      variables: {
        mandataryRates: [
          {
            exellentRate: percentToRate(newExellentRate),
            teg: percentToRate(newTeg),
            goodRate: percentToRate(newGoodRate),
            year,
          },
        ],
      },
    });

    handleClose();
  };

  const error: boolean = newTeg === '';

  return (
    <Dialog
      open={true}
      onClose={handleClose}
      aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">
        Modification du Taux Effectif Global
      </DialogTitle>

      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          {...{
            margin: 'dense',
            id: 'year',
            label: 'Durée',
            value: `${year} ans`,
            disabled: true,
            name: 'year',
          }}
        />

        <TextField
          fullWidth
          {...{
            id: 'teg',
            margin: 'dense',
            label: 'Taux excellent',
            name: 'teg',
            type: 'number',
            error,
            value: newExellentRate,
            onChange: (e) => setNewExellentRate(e.target.value),
            inputProps: { min: 0, step: 0.1 },
          }}
        />

        <TextField
          autoFocus
          fullWidth
          {...{
            id: 'teg',
            margin: 'dense',
            label: 'Taux très bon',
            name: 'teg',
            type: 'number',
            error,
            value: newTeg,
            onChange: (e) => setNewTeg(e.target.value),
            inputProps: { min: 0, step: 0.1 },
          }}
        />

        <TextField
          fullWidth
          {...{
            id: 'teg',
            margin: 'dense',
            label: 'Taux bon',
            name: 'teg',
            type: 'number',
            error,
            value: newGoodRate,
            onChange: (e) => setNewGoodRate(e.target.value),
            inputProps: { min: 0, step: 0.1 },
          }}
        />
      </DialogContent>

      <ConfirmationButtons
        handleCancel={handleClose}
        handleConfirm={handleEditTEG}
        disableConfirm={error}
      />
    </Dialog>
  );
};
export default EditTEG;
